import $ from 'jquery';
import 'what-input';
import { Carousel, Fancybox } from '@fancyapps/ui';
import { Thumbs } from '@fancyapps/ui/dist/carousel/carousel.thumbs.esm';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

// Function to adjust the number of visible page numbers on mobile devices

document.addEventListener('DOMContentLoaded', function() {
    const pagination = document.querySelector('.pagination');
    if (!pagination) return; // Exit if pagination element is not found

    const pageItems = pagination.querySelectorAll('li');
    const totalPages = pageItems.length;
    const maxVisiblePages = 3; // Adjust this number as needed

    if (window.innerWidth <= 600) {
        pageItems.forEach((item, index) => {
            if (index > 1 && index < totalPages - 1) {
                item.classList.add('hidden-mobile');
            }
        });

        // Show first, last, and current page numbers
        pageItems[0].classList.remove('hidden-mobile');
        pageItems[totalPages - 1].classList.remove('hidden-mobile');
        const currentPage = pagination.querySelector('.current');
        if (currentPage) {
            currentPage.classList.remove('hidden-mobile');
            const prevPage = currentPage.previousElementSibling;
            const nextPage = currentPage.nextElementSibling;
            if (prevPage) prevPage.classList.remove('hidden-mobile');
            if (nextPage) nextPage.classList.remove('hidden-mobile');
        }
    }
});

// Mega Menu functionality
$(function() {		
    $('.mega-menu__dropdown').hide();
    $('.mega-menu__toggle').click(function(e) {
        e.preventDefault();
        var menu = $(this).closest('.mega-menu__item').find('.mega-menu__dropdown').first();
        menu.slideToggle(400);		   
        $('.mega-menu__dropdown').not(menu).slideUp();
        $('.mega-menu__toggle').removeClass('active');
        $(this).toggleClass('active');
        menu.toggleClass('is-active');
        return false;
      });		 
    $(document).click(function(e) {
        // Only close if click is outside the mega menu
        if (!$(e.target).closest('.mega-menu').length) {
            $('.mega-menu__dropdown').slideUp();
            $('.mega-menu__dropdown').removeClass('is-active');
            $('.mega-menu__toggle').removeClass('active');
        }
    });
});

// Mobile Menu functionality 

$(document).ready(function() {
    $('.menu-icon').click(function() {
        $(this).toggleClass('active');
    });
    
});


document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.expander').forEach(function(expander) {
        expander.addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation(); // Prevent the parent link from being triggered
            const submenu = this.nextElementSibling;
            if (submenu) {
                submenu.classList.toggle('is-active');
                this.querySelector('i').classList.toggle('fa-square-plus');
                this.querySelector('i').classList.toggle('fa-square-minus');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const mobileNavContainer = document.querySelector('.c-mobile-nav__container');
    const toggleButtons = document.querySelectorAll('.menu-icon.hide-for-large');

    // Function to open the mobile nav
    function openMobileNav() {
        mobileNavContainer.classList.add('is-open');
        document.body.style.overflow = 'hidden'; // Prevent body from scrolling
    }

    // Function to close the mobile nav
    function closeMobileNav() {
        mobileNavContainer.classList.remove('is-open');
        document.body.style.overflow = ''; // Restore body scrolling
    }

    // Add event listeners to toggle buttons
    toggleButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            if (mobileNavContainer.classList.contains('is-open')) {
                closeMobileNav();
            } else {
                openMobileNav();
            }
        });
    });

    // Update submenu-toggle text and aria-label

    document.querySelectorAll('.submenu-toggle').forEach(function(button) {
        const parentLink = button.closest('li').querySelector('a');
        if (parentLink) {
            const parentLinkTitle = parentLink.textContent.trim();
            const submenuLabel = `${parentLinkTitle} submenu`;

            // Set aria-label and title attributes
            button.setAttribute('aria-label', submenuLabel);
            button.setAttribute('title', submenuLabel);

            // Update the text content of the .submenu-toggle-text span
            const toggleText = button.querySelector('.submenu-toggle-text');
            if (toggleText) {
                toggleText.textContent = submenuLabel;
            }
        }
    });
});


// Function to adjust the height of the Orbit container based on the content within it
function adjustOrbitHeight() {
    $('.orbit-container').each(function() {
        var $activeSlide = $(this).find('.orbit-slide.is-active');
        var newHeight = $activeSlide.outerHeight();
        $(this).css('height', newHeight);
    });
}

// Adjust height on page load
$(document).ready(function() {
    if ($('.orbit').length) {
        adjustOrbitHeight();
    }
});

// Adjust height on slide change
$('.orbit').on('slidechange.zf.orbit', function() {
    adjustOrbitHeight();
});

// Adjust height on window resize
$(window).on('resize', function() {
    if ($('.orbit').length) {
        adjustOrbitHeight();
    }
});


// Function to match orbit height to text cell
function matchOrbitHeight() {
    $('.b-page-content.full-image').each(function() {
        var $textCell = $(this).find('.text-cell');
        var $orbitFigure = $(this).find('.orbit-figure');
        var $orbitContainer = $(this).find('.orbit-container');
        
        if ($textCell.length && $orbitFigure.length) {
            var textHeight = $textCell.outerHeight();
            $orbitFigure.css('height', textHeight + 'px');
            $orbitContainer.css('height', textHeight + 'px');
        }
    });
}

// Run on page load
$(document).ready(function() {
    matchOrbitHeight();
});

// Run on window resize
$(window).on('resize', function() {
    matchOrbitHeight();
});

// Run when accordions are toggled
$(document).on('down.zf.accordion up.zf.accordion', function() {
    // Small delay to allow accordion animation to complete
    matchOrbitHeight();
});

// Run after Foundation orbit slide changes
$(document).on('slidechange.zf.orbit', function() {
    matchOrbitHeight();
});

//Testimonial slider read more on mobile instead of slider nav

document.addEventListener('DOMContentLoaded', function() {
    // Check if we are on the testimonial page
    if (!document.querySelector('.testimonial-page')) {
        return;
    }

    let currentIndex = 0;
    const testimonials = document.querySelectorAll('.orbit-slide');
    const readMoreButton = document.getElementById('read-more-button');

    function showNextTestimonials() {
        const nextIndex = currentIndex + 1;
        if (nextIndex < testimonials.length) {
            testimonials[nextIndex].style.display = 'block';
            currentIndex = nextIndex;
            if (nextIndex === testimonials.length - 1) {
                readMoreButton.style.display = 'none';
            }
        } else {
            readMoreButton.style.display = 'none';
        }
    }

    // Initially hide all testimonials except the first group
    testimonials.forEach((testimonial, index) => {
        if (index > 0) {
            testimonial.style.display = 'none';
        }
    });

    readMoreButton.addEventListener('click', showNextTestimonials);
});


//Blog and News link overlay hover event

document.addEventListener('DOMContentLoaded', function() {
    const teaseElements = document.querySelectorAll('.tease');

    teaseElements.forEach(tease => {
        const imageLink = tease.querySelector('.tease-image-link');
        const titleLink = tease.querySelector('.tease-title-link');
        const buttons = tease.querySelectorAll('.button, .text-link');
        buttons.forEach(button => {
            if (imageLink) {
                imageLink.addEventListener('mouseover', () => button.classList.add('hover'));
                imageLink.addEventListener('mouseout', () => button.classList.remove('hover'));
            }
    
            if (titleLink) {
                titleLink.addEventListener('mouseover', () => button.classList.add('hover'));
                titleLink.addEventListener('mouseout', () => button.classList.remove('hover'));
            }
        });
        
    });
});

// Gallery orbit slider reflow image batches for mobile

function handleResponsiveGallery() {
    const gallery = document.querySelector('.b-gallery .orbit');
    if (!gallery) return;

    const slides = gallery.querySelectorAll('.orbit-slide');
    const isMobile = window.innerWidth < 640; // Adjust this breakpoint as needed

    if (isMobile) {
        slides.forEach(slide => {
            const images = slide.querySelectorAll('.cell.image');
            images.forEach((image, index) => {
                if (index > 0) {
                    const newSlide = document.createElement('li');
                    newSlide.className = 'orbit-slide';
                    newSlide.appendChild(image);
                    slide.parentNode.insertBefore(newSlide, slide.nextSibling);
                }
            });
        });
    } else {
        // Revert to original structure if not mobile
        slides.forEach(slide => {
            const nextSlide = slide.nextElementSibling;
            while (nextSlide && nextSlide.classList.contains('orbit-slide') && slide.querySelectorAll('.cell.image').length < 3) {
                const image = nextSlide.querySelector('.cell.image');
                if (image) {
                    slide.appendChild(image);
                }
                nextSlide.parentNode.removeChild(nextSlide);
            }
        });
    }

    // Reinitialize the Orbit slider
    if (typeof Foundation !== 'undefined') {
        Foundation.reInit('orbit');
    }
}

// Call this function when the page loads and when the window is resized
window.addEventListener('load', handleResponsiveGallery);
window.addEventListener('resize', debounce(handleResponsiveGallery, 250));

// Debounce function to limit how often a function is called
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

const anchorLinks = document.querySelectorAll('.b-page-menu a[href^="#"], .employee-groups a[href^="#"], a.button[href^="#"]');
    
anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
        e.preventDefault();
        
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
            const offset = 120;
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
            
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.staff-dropdown-trigger').forEach(function(el) {
        el.addEventListener('click', function(e) {
        e.preventDefault();
        });
    });
});

// Gallery lightbox thumbnail slider
Fancybox.bind("[data-fancybox]", {
    
  });


$(document).ready(function() {
    // Close tooltip when clicking outside
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.gform-tooltip').length) {
            $('.tooltip-content').hide();
        }
    });

    // Handle touch devices and Reveal modal context
    function initializeTooltips(context) {
        const $context = context ? $(context) : $(document);
        
        $context.find('.tooltip-trigger').each(function() {
            const $trigger = $(this);
            const $tooltip = $trigger.siblings('.tooltip-content');
            const $reveal = $trigger.closest('.reveal');
            
            // Adjust z-index if inside reveal
            if ($reveal.length) {
                $tooltip.css('z-index', parseInt($reveal.css('z-index')) + 1);
            }

            // Handle click/touch events
            $trigger.off('click.tooltip').on('click.tooltip', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $('.tooltip-content').not($tooltip).hide();
                $tooltip.toggle();
            });
        });
    }

    // Initialize tooltips on page load
    initializeTooltips();

    // Initialize tooltips when Reveal opens
    $(document).on('open.zf.reveal', function(e) {
        initializeTooltips(e.target);
    });

    // Handle touch devices
    if ('ontouchstart' in window) {
        $(document).on('click', '.tooltip-trigger', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const tooltip = $(this).siblings('.tooltip-content');
            $('.tooltip-content').not(tooltip).hide();
            tooltip.toggle();
        });
    }
});

// Handle Gravity Form submission
$(document).on('gform_confirmation_loaded', function(event, formId) {
    if (formId === 4) {
        // Show success message or redirect
        console.log('Form submitted successfully');
    }
});

$(document).on('gform_submission_started', function(event, formId) {
    if (formId === 4) {
        // Show loading state
        const $submitButton = $('#gform_submit_button_' + formId);
        $submitButton.prop('disabled', true);
        $submitButton.find('span:first').hide();
        $submitButton.find('span:last').removeClass('hide');
    }
});

$(document).on('gform_submission_complete', function(event, formId) {
    if (formId === 4) {
        // Reset button state
        const $submitButton = $('#gform_submit_button_' + formId);
        $submitButton.prop('disabled', false);
        $submitButton.find('span:first').show();
        $submitButton.find('span:last').addClass('hide');
    }
});

